import { fetchWithRetry } from '@/utils';

export const totalUnreadCount = async () =>
  fetchWithRetry('/api/v2/call', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'total-unread-count',
    }),
  })
    .then(res => res.json())
    .then(res => res.result);
